import ScheduleModal from './ScheduleModal';

export default ScheduleModal;
